import { useMemo } from "react";

import { useLabels } from "~/hooks/useLabels";
import { useBreakpoints } from "~/hooks/useBreakpoints";

import { SheetModal } from "../sheetModal/SheetModal";
import { Divider } from "../divider/Divider";
import { Button } from "../button/Button";
import { Menu } from "../menu/Menu";
import { MenuItem } from "../menu/MenuItem";
import { Entity } from "../entity/Entity";
import { DialogModal } from "../dialogModal/DialogModal";

import type { ActionProp } from "../components";

export interface SlideActionsModalProps {
  actions?: ActionProp[];
  isOpen?: boolean;
  postTitle: string;
  title: string;
  onRequestCancel?: () => void;
  onRequestClose?: () => void;
}

const DEFAULT_LABELS = {
  "common.cta.cancel": "Cancel",
};

export function SlideActionsModal({
  actions,
  isOpen,
  postTitle,
  title,
  onRequestCancel,
  onRequestClose,
}: SlideActionsModalProps) {
  const { t } = useLabels({ fallback: DEFAULT_LABELS });

  const breakpoints = useBreakpoints();

  const style = {
    "--sheet-modal-z-index": 82,
  };

  const content = useMemo(() => {
    return (
      <>
        <Entity title={title} postTitle={postTitle} />

        <Divider />

        <Menu>
          {actions?.map(({ icon, text, onClick }) => (
            <MenuItem key={text} icon={icon} onClick={onClick}>
              {text}
            </MenuItem>
          ))}
        </Menu>

        <Button
          appearance="secondary"
          fill
          style={{ marginBlockStart: "var(--size-2)" }}
          onClick={onRequestCancel ?? onRequestClose}
        >
          {t("common.cta.cancel")}
        </Button>
      </>
    );
  }, [actions, onRequestCancel, onRequestClose, postTitle, t, title]);

  return breakpoints.lg ? (
    <DialogModal isOpen={isOpen} size="sm" onRequestClose={onRequestClose}>
      <DialogModal.Body>{content}</DialogModal.Body>
    </DialogModal>
  ) : (
    <SheetModal isOpen={isOpen} style={style} onRequestClose={onRequestClose}>
      <SheetModal.Body>{content}</SheetModal.Body>
    </SheetModal>
  );
}
